module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA6ElEQVR4AbRTAQ6CMAwcTv/BU+AnkrglvIL4CpLNRHyJ+BLlHTJnD7MF3UhQA8mF9tpey+hW7M/HC2itK6UOx7lwfb2AtUkq5a6YA1eMtxeA8wuiAkqp7Sfquk5jDQKBqcRYMbhAoCzLGwJjSCmbGI+cQGCRCdBpCstMgG8eY6o7+GACkN/gTYDWOaNVvrqDJH9YbwiCU0qficvgO4wFMmtZZcw953w93AlrbcfY40JFFecbivUFcVgoL+IFksQ2Uooc/9uYvkChOwcq6ih+esVMS3YTTCCE2DsSiSh2PmyKt/ARI9vnPgEAAP//m/vyBgAAAAZJREFUAwBbiqUh2dUlaQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/invoice.png
// module id = v0Fz
// module chunks = 3